'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.meta = undefined;

var _metaMiddleware;

var _jalan = require('jalan');

var _routing = require('../constants/routing');

var _data = require('../constants/data');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* injects from baggage-loader */

var meta = exports.meta = (0, _jalan.metaMiddleware)((_metaMiddleware = {}, _defineProperty(_metaMiddleware, _routing.JALAN_USER_LIST, { data: [_data.PROJECTS_DATA] }), _defineProperty(_metaMiddleware, _routing.JALAN_INDEX, { data: [_data.PROJECTS_DATA] }), _defineProperty(_metaMiddleware, _routing.JALAN_INDEX_PROJECT, { data: [_data.PROJECTS_DATA, _data.PROJECT_DATA] }), _defineProperty(_metaMiddleware, _routing.JALAN_PROJECT, { data: [_data.PROJECTS_DATA, _data.PROJECT_DATA] }), _defineProperty(_metaMiddleware, _routing.JALAN_PROJECT_NODE, { data: [_data.PROJECT_DATA, _data.NODE_DATA] }), _defineProperty(_metaMiddleware, _routing.JALAN_NODE, { data: [_data.NODE_DATA, _data.PROJECT_DATA] }), _defineProperty(_metaMiddleware, _routing.JALAN_TEST, { data: [_data.PROJECT_DATA] }), _metaMiddleware));


//////////////////
// WEBPACK FOOTER
// ./app/store/meta.js
// module id = 641
// module chunks = 1